export enum PropertyType {
  Homes = "homes",
  CondosAndTownhomes = "condos-and-townhomes",
  MultiFamily = "multi-family",
  Land = "land",
  Ranch = "ranch",
  Commercial = "commercial",
}

export enum PropertyFeature {
  TetonView = "teton-view",
  NoSubdivisions = "no-subdivisions",
  TreesOnLot = "trees-on-lot",
  WaterOnLot = "water-on-lot",
}

export enum ListingStatus {
  Active = "active",
}

export enum Sort {
  Newest = "newest",
  PriceDescending = "price-descending",
  PriceAscending = "price-ascending",
}
